import { CargoPickupPage } from "@/pages";

const allowedDomains = [
    "https://xn----stbeziy.xn--p1ai",
    "https://website-tk-luch-rf-test.int.otr-it.net"
];

export default {
    name: "App",
    components: {
        CargoPickupPage,
    },
    mounted() {
        this.$_resizeObserver = new ResizeObserver(() => {
            if (document.querySelector('.el-overlay')) return; // dialog is open, skip

            const parentOrigin = allowedDomains.find(domain => document.referrer.startsWith(domain));
            if (parentOrigin) {
                window.parent.postMessage(
                    { type: 'resize', height: document.body.scrollHeight },
                    parentOrigin
                );
            }
        });

        this.$_resizeObserver.observe(document.body);
    },
    beforeUnmount() {
        this.$_resizeObserver?.disconnect();
    },
};